export default __webpack_public_path__ + "static/media/47.52269a22.png";